const STORAGE_KEY = 'user-state';

export const persistUserState = (state) => localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
export const getPersistedUserState = () => JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
